<template>
  <div class="produceInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      損耗率
    </li>
    <b-table
      :items="produceInformationItem"
      :fields="produceInformationFields"
      class="text-center produceInformation-table-detail"
    >
      <template #thead-top="">
        <b-tr>
          <b-th rowspan="2">製程</b-th>
          <b-th rowspan="2">生產前總重(KG)</b-th>
          <b-th rowspan="2">生產總重(KG)</b-th>
          <b-th colspan="2">損耗率(%)</b-th>
        </b-tr>
        <b-tr>
          <b-th> 實際 </b-th>
          <b-th> 標準 </b-th>
        </b-tr>
      </template>
      <template #cell(process)="data">
        {{ data.item.process }}
        <span style="color: #c10000">
          {{ data.item.rework ? "(重工)" : "" }}
          <!-- {{
            data.item.rework && data.item.ht_in_process !== "-"
              ? "(" + data.item.ht_in_process + "重工)"
              : ""
          }} -->
        </span>
      </template>
      <template #cell(pre_total_weight)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
      <template #cell(total_weight)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
      <template #cell(attrition_rate_act)="data">
        <div
          :style="{
            color:
              produceInformationItem[data.index].attrition_rate_act >
              produceInformationItem[data.index].attrition_rate_standard
                ? '#c10000'
                : '#212529'
          }"
        >
          {{ data.value }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "produceInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      produceInformationFields:
        "produceInformation/get_produceInformationFields",
      produceInformationItem: "produceInformation/get_produceInformationItem"
    })
  }
};
</script>

<style lang="scss">
.produceInformation-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.produceInformation-table-detail thead th {
  border-top: 1px solid;
}
.produceInformation-table-detail th,
.produceInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.produceInformation-table-detail td {
  font-size: 1rem;
}
.produceInformation-table-detail th:first-child,
.produceInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.produceInformation-table-detail {
  margin-bottom: 0px;
}
.produceInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.produceInformation-table-detail tr td {
  background-color: #ffffff;
}
.produceInformation-table-detail thead tr:nth-child(3) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/produceInformation.vue